import { stipAxios } from '../axios';
import { EXTERNAL_CONTEXT } from 'app/config/urls';
import { SERVICES_GROUPS } from 'app/config/services';

const BASE_ENDPOINT = '/solicitacao';

const requestEndpoints = {
    statusSyncDoc: (cdSolicitacao) => stipAxios.get(`${BASE_ENDPOINT}/syncdoc/${cdSolicitacao}`),
    finishRequest: (cdSolicitacao) =>
        stipAxios.put(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/finalizar/${cdSolicitacao}`, {}),

    approveRequest: ({ request, cdCertificado }) => {
        let endpoint = `${BASE_ENDPOINT}/aprovar/${request.cdSolicitacao}`;
        if (SERVICES_GROUPS.VEHICLES.includes(request.cdServico)) {
            endpoint = `${BASE_ENDPOINT}/veiculos/aprovar/${request.cdSolicitacao}`;
        } else if (SERVICES_GROUPS.LICENSE.includes(request.cdServico)) {
            endpoint = `${BASE_ENDPOINT}/licenca/aprovar/${request.cdSolicitacao}/${cdCertificado}`;
        } else if (
            SERVICES_GROUPS.LINES_STRIP.includes(request.cdServico) ||
            SERVICES_GROUPS.LINES_SLIC.includes(request.cdServico)
        ) {
            endpoint = `${BASE_ENDPOINT}/aprovar/${request.cdSolicitacao}`;
        }
        return stipAxios.put(endpoint, {});
    },
    disapproveRequest: (cdSolicitacao, payload) => stipAxios.put(`${BASE_ENDPOINT}/reprovar/${cdSolicitacao}`, payload),
    cancelRequest: (cdSolicitacao, payload, context = EXTERNAL_CONTEXT) =>
        stipAxios.put(`${context}${BASE_ENDPOINT}/cancelar/${cdSolicitacao}`, payload),

    saveRequestChangeEmail: (payload) => stipAxios.post(`/guest${BASE_ENDPOINT}/alterar-email`, payload),
    saveRequestAccessPortal: (payload) => stipAxios.post(`/guest${BASE_ENDPOINT}/acesso-portal`, payload),
    saveRequest: (payload, context = EXTERNAL_CONTEXT) => stipAxios.post(`${context}${BASE_ENDPOINT}/save`, payload),

    getDiffRequest: (cdSolicitacao) => stipAxios.get(`${BASE_ENDPOINT}/${cdSolicitacao}/diff/empresa`),

    findRequest: (param, context = EXTERNAL_CONTEXT) =>
        stipAxios.post(`${context}${BASE_ENDPOINT}/find`, {
            ...param,
        }),

    getNewRequest: (param, context = EXTERNAL_CONTEXT) =>
        stipAxios.post(`${context}${BASE_ENDPOINT}/new`, {
            ...param,
        }),

    dadosOperador: (cdSolicitacao) => stipAxios.get(`${BASE_ENDPOINT}/${cdSolicitacao}/dadosOperador`),

    //GENERAL
    getRequests: (params, context = EXTERNAL_CONTEXT) => {
        const { page, size } = params;
        let endpoint = `${context}${BASE_ENDPOINT}/find`;
        if (page !== undefined) {
            endpoint = `${context}${BASE_ENDPOINT}/pages/${page}/${size ? size : 10}`;
        }
        return stipAxios.post(endpoint, {
            ...params,
        });
    },
};

export default requestEndpoints;
